import * as yup from 'yup';
import { PhaseType } from '../../../types/ScientificModule';

export const CreatePhaseFormValidation = yup.object<PhaseType>().shape({
  id: yup.string().optional(),
  description: yup.string().required('Descrição é obrigatória'),
  start: yup.boolean().required('O campo "Início" é obrigatório'),
  end: yup.boolean().required('O campo "Fim" é obrigatório'),
  idProjectType: yup.string().required('Tipo de projeto é obrigatório'),
  status: yup.boolean().optional(),

  idPhasePrevious: yup
    .string()
    .when('start', {
      is: true, 
      then: () => yup.string().strip(),
      otherwise: () => yup.string()
        .nullable()
        .test('not-same-as-next', 'Fase anterior não pode ser igual à fase seguinte', function(value) {
          const { idPhaseNext } = this.parent;
          return !value || !idPhaseNext || value !== idPhaseNext;
        })
    }),

  idPhaseNext: yup
    .string()
    .when('end', {
      is: true, 
      then: () => yup.string().strip(), 
      otherwise: () => yup.string()
        .nullable()
        .test('not-same-as-previous', 'Fase seguinte não pode ser igual à fase anterior', function(value) {
          const { idPhasePrevious } = this.parent;
          return !value || !idPhasePrevious || value !== idPhasePrevious;
        })
    }),
});

